import { render, staticRenderFns } from "./Contracts.vue?vue&type=template&id=fa683d30&scoped=true"
import script from "./Contracts.vue?vue&type=script&lang=js"
export * from "./Contracts.vue?vue&type=script&lang=js"
import style0 from "./Contracts.vue?vue&type=style&index=0&id=fa683d30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa683d30",
  null
  
)

export default component.exports